<template>
  <div class="hs"></div>
</template>

<script>
  import Highcharts from 'highcharts'
  import Themes from './highcharts-themes'
  import Theme from './themes/google'

  export default {
    props: ['chart'],
    data () {
      return {
        target: undefined
      }
    },
    methods: {
      renderChart () {
        this.target = Highcharts.chart(this.$el, {
          title: {
            text: this.chart.name,
            x: -20
          },
          xAxis: {
            categories: this.chart.categories
          },
          yAxis: {
            title: {
              text: 'Mentions count'
            },
            plotLines: [{
              value: 0,
              width: 1,
              color: '#808080'
            }]
          },
          tooltip: {
            valueSuffix: ' mentions'
          },
          legend: {
            align: 'center',
            verticalAlign: 'bottom',
            borderWidth: 0
          },
          series: this.chart.series,
          credits: false
        })
      }
    },
    mounted () {
      Highcharts.setOptions(Theme)
      this.renderChart()
      // window.addEventListener('resize', () => {
      //   this.target.redraw()
      // }, true)
    },
    watch: {
      chart () {
        this.renderChart()
      }
    }
  }
</script>

<style scoped>
  .hs {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/report/Chart.vue